import Data from './Data';
import type { BlockEditProps } from '@plone/types';

const SliderSidebar = (props: BlockEditProps) => {
  return <Data {...props} />;
};

export default SliderSidebar;
